export default "__VITE_ASSET__30601175__"